import { useEffect } from 'react';
import { UseFormReturn, useWatch } from 'react-hook-form';
import { OrderHeadersGroupByEnum } from '../../../products/orderProducts.types';
import { ExportOrderForm } from '../ExportOrderModal.types';
import { parseGroupByEnumPrefix } from '../utils/exportOrder.utils';

const useGroupByClassification = (form: UseFormReturn<ExportOrderForm>) => {
  const groupBySelected = useWatch({ control: form.control, name: 'groupBy' });

  useEffect(() => {
    const parsedGroupOption = parseGroupByEnumPrefix(groupBySelected);
    const currentClassificationTypeId = form.getValues('classificationTypeId');

    if (
      parsedGroupOption &&
      parsedGroupOption.groupBy === OrderHeadersGroupByEnum.COLOR_CLASSIFICATION_TYPE &&
      parsedGroupOption.classificationTypeId
    ) {
      const classificationTypeId = parsedGroupOption.classificationTypeId;

      if (form.getValues('classificationTypeId') !== classificationTypeId) {
        form.setValue('classificationTypeId', classificationTypeId, {
          shouldDirty: true,
          shouldValidate: true,
        });
      }
      return;
    }

    if (currentClassificationTypeId != null) {
      form.setValue('classificationTypeId', undefined, {
        shouldDirty: true,
        shouldValidate: true,
      });
    }
  }, [groupBySelected, form]);
};

export default useGroupByClassification;
